module.exports = __webpack_public_path__ + "img/logoAsa24.254bd58e.png";